import { Injectable, inject } from '@angular/core';
import { User } from '@app/core/models/user.model';
import { AuthService } from '@app/core/auth/auth.service';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class UserService {
    private authService = inject(AuthService);

    public get isAuthenticated(): boolean {
        return this.authService.isAuthenticated();
    }

    public get currentUser(): User {
        if (!this.isAuthenticated) {
            return <User>{
                name: environment.authEnabled
                    ? ''
                    : `Auth disabled for ${environment.envName}`,
            };
        }
        let name = '';
        let tenantId = '';
        if (<any>this.authService.getIdentityClaims()) {
            name = (<any>this.authService.getIdentityClaims()).name;
            tenantId = (<any>this.authService.getIdentityClaims()).tenantId;
        }

        return <User>{
            name: name,
            tenantId: tenantId,
        };
    }
}
